import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />

      <main className="pt-24 pb-20">
        <div className="max-w-3xl mx-auto px-6">
          <h1 className="font-outfit text-4xl font-semibold tracking-tight mb-8" data-testid="privacy-title">
            Privacy Policy
          </h1>
          
          <div className="prose prose-invert max-w-none space-y-8 text-muted-foreground">
            <p className="text-sm">Last updated: January 2026</p>

            <section>
              <h2 className="font-outfit text-xl font-semibold text-foreground mb-4">1. Information We Collect</h2>
              <p>We collect information you provide directly to us, including:</p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Contact information (name, email, phone number)</li>
                <li>Vehicle information (make, model, year, condition)</li>
                <li>Location information (pickup and delivery addresses)</li>
                <li>Payment information (processed securely via Stripe)</li>
                <li>Communication records (emails, SMS, calls)</li>
              </ul>
            </section>

            <section>
              <h2 className="font-outfit text-xl font-semibold text-foreground mb-4">2. How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Process and fulfill your transport requests</li>
                <li>Communicate with you about your booking</li>
                <li>Connect you with verified carriers</li>
                <li>Send updates and notifications about your transport</li>
                <li>Improve our services and customer experience</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section>
              <h2 className="font-outfit text-xl font-semibold text-foreground mb-4">3. Information Sharing</h2>
              <p>
                We share your information with carriers in our network to facilitate transport. 
                We do not sell your personal information to third parties. We may share information:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>With carriers assigned to your transport</li>
                <li>With payment processors (Stripe) for transactions</li>
                <li>When required by law or legal process</li>
                <li>To protect our rights and safety</li>
              </ul>
            </section>

            <section>
              <h2 className="font-outfit text-xl font-semibold text-foreground mb-4">4. Data Security</h2>
              <p>
                We implement appropriate technical and organizational measures to protect your 
                personal information. Payment information is processed securely through Stripe 
                and is never stored on our servers.
              </p>
            </section>

            <section>
              <h2 className="font-outfit text-xl font-semibold text-foreground mb-4">5. Your Rights</h2>
              <p>You have the right to:</p>
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li>Access your personal information</li>
                <li>Correct inaccurate information</li>
                <li>Request deletion of your information</li>
                <li>Opt out of marketing communications</li>
              </ul>
            </section>

            <section>
              <h2 className="font-outfit text-xl font-semibold text-foreground mb-4">6. Cookies & Tracking</h2>
              <p>
                We use cookies and similar technologies to improve your experience, analyze 
                site traffic, and personalize content. You can control cookie settings through 
                your browser preferences.
              </p>
            </section>

            <section>
              <h2 className="font-outfit text-xl font-semibold text-foreground mb-4">7. Contact Us</h2>
              <p>
                For privacy-related questions or to exercise your rights, contact us at 
                privacy@shiptesla.com or call 1-800-555-1234.
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
